<template>
	<page enable-flex style="background: #fff">
		<div class="model flex-center">
			<p v-if="modelData">{{modelData.category.name}} | {{modelData.brand.name}} | {{modelData.model.name}}</p>
			<p v-else>请选择产品型号</p>
			<a class="flex-center" @click="$refs.model.open()"><i class="tf-edit"></i></a>
		</div>
		<c-form ref="form" style="padding-top: 0;">
			<c-form-item label="背贴码" required>
				<scan-code @success="val => $refs.unicode.set(val)">
					<c-input ref="unicode" name="produce_unique_code"></c-input>
				</scan-code>
			</c-form-item>
			<c-form-item label="IMEI码" required>
				<a class="m-gen-imei" @click="generateImei"><i class="tf">&#xe76b;</i>自动生成</a>
				<scan-code @success="val => $refs.imei.set(val)">
					<c-input ref="imei" name="produce_imei"></c-input>
				</scan-code>
			</c-form-item>
			<c-form-item label="货款结算方" required tip="即最终的采购货款结算给谁">
				<c-select v-model="payeeUserType" name="payee_user_type" :options="payeeUserTypeOptions" :clear="false"></c-select>
			</c-form-item>
			<c-form-item label="采购部门" required>
				<c-select v-model="currentDepartment" name="purchase_dept_id" async @search="searchDepartment" @change="$refs.staffSelect.set()"></c-select>
			</c-form-item>
			<c-form-item label="采购人" required>
				<c-select ref="staffSelect" name="purchase_user_id" :disabled="!currentDepartment" :placeholder="!currentDepartment ? '请先选择采购部门' : '请选择'" async @search="searchUser"></c-select>
			</c-form-item>
			<c-form-item label="仓管部门" required>
				<c-select v-model="createDeptId" name="create_dept_id" :options="createDeptOptions"></c-select>
			</c-form-item>
			<c-form-item label="供应商" :required="payeeUserType == 2">
				<c-select v-model="currentSupplier" name="supplier_id" async @search="searchSupplier" @change="$refs.contactSelect.set()"></c-select>
			</c-form-item>
			<c-form-item label="供应商联系人" :required="payeeUserType == 2">
				<c-select ref="contactSelect" name="supplier_contact_id" :disabled="!currentSupplier" :placeholder="!currentSupplier ? '请先选择供应商' : '请选择'" async @search="searchContact"></c-select>
			</c-form-item>
			<c-form-item label="等级">
				<c-radio-group name="level_type" :options="LEVEL_TYPE"></c-radio-group>
			</c-form-item>

			<c-form name="attr">
<!--				<c-form-item v-for="(field, i) in attrField" :key="i" :label="field.attribute_name" :required="field.required == 1">-->
				<c-form-item v-for="(field, i) in attrField" :key="i" :label="field.attribute_name">
					<c-input v-if="field.attribute_type == 1"
						v-model="field.attribute_value"
						:name="field.parent_id"
					></c-input>

					<c-input v-if="field.attribute_type == 2"
						v-model="field.attribute_value"
						:name="field.parent_id"
						type="number"
						:decimal="field.config_json.decimal"
					></c-input>

					<c-datetime v-else-if="field.attribute_type == 3"
						v-model="field.attribute_value"
						:name="field.parent_id"
						:type="field.config_json.format.split('|')[1]"
						:format="field.config_json.format.split('|')[0]"
					></c-datetime>

					<c-radio-group v-else-if="field.attribute_type == 4"
						v-model="field.attribute_id"
						:name="field.parent_id"
						:options="field.attribute_value_list"
					></c-radio-group>

					<c-upload-file v-else-if="field.attribute_type == 5"
						v-model="field.attribute_value"
						:name="field.parent_id"
					></c-upload-file>

					<c-upload-file v-else-if="field.attribute_type == 6"
						v-model="field.attribute_value"
						:name="field.parent_id"
						type="image"
						media
						:side="false"
					></c-upload-file>
				</c-form-item>
			</c-form>

			<c-form-item label="外部单号">
				<c-input name="out_order_number"></c-input>
			</c-form-item>
			<c-form-item label="同行价">
				<c-input name="market_price" type="number" decimal="2" append-text="元"></c-input>
			</c-form-item>
			<c-form-item label="零售价">
				<c-input name="retail_price" type="number" decimal="2" append-text="元"></c-input>
			</c-form-item>
			<c-form-item label="备注">
				<c-input name="remark" type="textarea"></c-input>
			</c-form-item>
		</c-form>

		<template #button>
			<div class="foot flex-between-center">
				<div class="foot-input flex-center">
					<label>采购价：</label>
					<c-input v-model="purchasePrice" type="number" decimal="2" append-text="元" placeholder="请输入"></c-input>
				</div>
				<c-button class="foot-button" size="form" color="main" @click="submitHandle">确认提交</c-button>
			</div>
		</template>

		<model ref="model" :close-button="!!modelData" @resolve="modelHandle"></model>
	</page>
</template>

<script>
	import model from './product_model.vue'
	import {asyncMapState} from '@/store'

	export default {
		components: {
			model
		},

		data() {
			return {
				modelData: null,
				payeeUserType: 1,
				payeeUserTypeOptions: [{
					name: '采购员',
					value: 1
				}, {
					name: '供应商',
					value: 2
				}],
				currentDepartment: '',
				currentSupplier: '',
				createDeptId: '',
				createDeptOptions: [],
				attrField: [],
				purchasePrice: ''
			}
		},

		computed: {
			...asyncMapState(['LEVEL_TYPE'])
		},

		mounted() {
			this.$refs.model.open();
			//加载登录人所属部门列表，只有一个部门时自动选中
			this.request({
				url: '/sys_user/my_department_list',
				success: data => {
					this.createDeptOptions = (data || []).map(item => {
						return {
							name: item.department_name,
							value: item.id
						};
					});
					if (this.createDeptOptions.length == 1) {
						this.createDeptId = this.createDeptOptions[0].value;
					}
				}
			});
		},
		
		methods: {
			modelHandle(data) {
				this.modelData = data;
				this.attrField = [];
				this.request({
					url: '/spu/model/attribute/list',
					data: {
						type: 1, //SKU配置类型（0：toC端，1：toB端），与提交校验口径一致
						model_id: data.model.value
					},
					success: data => {
						data.forEach(item => {
							item.parent_id = item.parent_id.toString();
							if (item.attribute_value_list) {
								item.attribute_value_list = item.attribute_value_list.map(item => {
									return {
										name: item.attribute_value,
										value: item.attribute_id
									}
								});
							}
						})
						this.attrField = data;
					}
				})
			},

			searchSupplier(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						keyword,
						options_code: 'SUPPLIER'
					},
					success: resolve
				})
			},

			searchContact(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						keyword,
						options_code: 'SYSUSER',
						user_type: 2,
						supplier_id: this.currentSupplier
					},
					success: resolve
				})
			},

			searchDepartment(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						keyword,
						options_code: 'DEPARTMENT'
					},
					success: resolve
				})
			},

			searchUser(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						keyword,
						options_code: 'SYSUSER',
						user_type: 1,
						department_id: this.currentDepartment
					},
					success: resolve
				})
			},

			//生成虚拟串号并回填（无实物串号可扫时使用）
			generateImei() {
				this.request({
					url: '/imei/generate',
					loading: true,
					success: data => {
						this.$refs.imei.set(data)
					}
				})
			},

			submitHandle() {
				let extendRule = {}
				/*this.attrField.forEach(field => {
					if (field.required == 1) {
						extendRule[`attr.${field.parent_id}`] = `${field.attribute_name}不能为空`;
					}
				});*/
				this.$refs.form.validate({
					rule: {
						produce_unique_code: '请输入背贴码',
						produce_imei: '请输入IMEI码',
						purchase_dept_id: '请选择采购部门',
						create_dept_id: {
							check: '请选择创建部门',
							//登录人无归属部门时不强制
							skip: () => this.createDeptOptions.length == 0 && !this.createDeptId
						},
						purchase_user_id: '请选择采购人',
						supplier_id: {
							check: '请选择供应商',
							skip: () => this.payeeUserType != 2
						},
						supplier_contact_id: {
							check: '请选择供应商联系人',
							skip: () => this.payeeUserType != 2
						},
						// level_type: '请选择等级',
						...extendRule
					},
					success: data => {
						if (!this.purchasePrice) {
							this.$message({
								message: '请填写采购价'
							});
							return;
						}

						this.request({
							url: '/offline/purchase/order/add',
							data: Object.assign(data, {
								spu_model_id: this.modelData.model.value,
								purchase_price: this.purchasePrice,
								attribute_value_list: this.attrField.map(field => {
									return {
										parent_id: field.parent_id,
										attribute_id: field.attribute_id || 0,
										attribute_value: field.attribute_type == 4 && field.attribute_id
											? field.attribute_value_list.find(item => item.value == field.attribute_id).name
											: field.attribute_value
									}
								})
							}),
							loading: true,
							success: () => {
								this.$message({
									message: '提交成功',
									mask: true
								});
								this.mp.navigateBack(true);
							}
						});
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.model {
		gap: .12rem;
		height: 1rem;

		p {
			font-size: .3rem;
			font-weight: 600;
		}

		a {
			width: .48rem;
			height: .48rem;
			border-radius: 50%;
			font-size: .24rem;
			color: #fff;
			background: var(--color-main);
		}
	}

	/*上浮到IMEI标题行右侧，负值为标题行高度，偏移不对时只调这一个数*/
	.m-gen-imei {
		display: block;
		height: .72rem;
		margin-top: -.72rem;
		font-size: .26rem;
		line-height: .72rem;
		text-align: right;
		color: var(--color-main);

		.tf {
			margin-right: .06rem;
			font-size: .28rem;
		}
	}

	.foot {
		width: 100%;

		&-input {
			label {
				font-size: .3rem;
				font-weight: 600;
				white-space: nowrap;
				color: #f00;
			}

			>>> .c-input {
				width: 2.4rem;
				height: .72rem;
				background: #FFFAAD;
			}
		}

		&-button {
			max-width: 2.6rem;
		}
	}
</style>